<div data-testid="package-spu-page" class="p-4 flex-table-page routed-flex-table-page">
  <!-- Search Form -->
  <app-search-form
    data-testid="package-spu-search-form"
    [searchFormat]="searchFormConfig"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions">
      <app-status-filter
        [primaryButton]="primaryButton()"
        (primaryButtonClick)="onAdd()"
      ></app-status-filter>
    </div>
  </app-search-form>

  <!-- Data Table -->
  <div class="flex-table-section">
    <app-data-table
      data-testid="package-spu-table"
      [dataSource]="spus()"
      [columns]="columns"
      [rows]="rows"
      [first]="first"
      [totalRecords]="totalRecords()"
      [loading]="loading()"
      scrollHeight="flex"
      (pageChange)="onPageChange($event)"
    >
    <!-- Custom Template for Type Column -->
    <ng-template #customTemplate let-value let-column="column">
      @if (column?.prop === "type") {
        <span class="text-xs flex items-center justify-center">
          {{ getTypeDisplayText(value) }}
        </span>
      }
      @if (column?.template === "categoryTemplate") {
        <span
          class="text-xs text-gray-700 truncate cursor-help"
          [pTooltip]="value"
          tooltipPosition="top"
          tooltipStyleClass="custom-tooltip"
          [showDelay]="300"
          [hideDelay]="0"
        >
          {{ value }}
        </span>
      }
    </ng-template>

    <!-- Custom Status Template -->
    <ng-template #statusTemplate let-status>
      <div class="flex items-center justify-center gap-1">
        <p-tag
          data-testid="package-spu-status-tag"
          [value]="
            (status ? getActiveDisplayText() : getInactiveDisplayText())
              | translate
          "
          [severity]="status ? getActiveSeverity() : getInactiveSeverity()"
          styleClass="status-tag"
          [ngStyle]="getStatusStyle(status)"
          pTooltip="{{
            status
              ? 'common.table.status.active'
              : ('common.table.status.inactive' | translate)
          }}"
          tooltipPosition="top"
          tooltipStyleClass="custom-tooltip"
          [showDelay]="300"
          [hideDelay]="0"
        />
      </div>
    </ng-template>

    <!-- Custom Actions Template -->
    <ng-template #actionsTemplate let-spu>
      <div class="flex gap-2 justify-center">
        @if (canRead()) {
          <app-button
            [testId]="'package-spu-action-view-' + spu.id"
            class="action-view"
            [label]="'common.actions.view' | translate"
            type="action"
            (emitOnClick)="onView(spu)"
          ></app-button>
        }

        @if (canUpdate()) {
          <app-button
            [testId]="'package-spu-action-edit-' + spu.id"
            class="action-edit"
            [label]="'common.actions.edit' | translate"
            type="action"
            (emitOnClick)="onEdit(spu)"
          ></app-button>
        }

        @if (canApprove()) {
          <app-button
            [testId]="'package-spu-action-toggle-status-' + spu.id"
            [class]="spu.status ? 'action-disable' : 'action-enable'"
            [label]="
              (spu.status
                ? 'common.table.actions.deactivate'
                : 'common.table.actions.activate'
              ) | translate
            "
            type="action"
            (emitOnClick)="spu.status ? onDisable(spu) : onEnable(spu)"
          ></app-button>
        }

        @if (canDelete() && !spu.status) {
          <app-button
            [testId]="'package-spu-action-delete-' + spu.id"
            class="action-delete"
            [label]="'common.actions.delete' | translate"
            type="action"
            (emitOnClick)="onDelete(spu)"
          ></app-button>
        }
      </div>
    </ng-template>
    </app-data-table>
  </div>
</div>

<!-- Toast Messages -->
<p-toast data-testid="package-spu-toast"></p-toast>
<!-- Shared Confirmation Dialog -->
<app-confirmation-dialog
  [testId]="'package-spu-confirmation-dialog'"
  [(visible)]="showConfirmationDialog"
  [title]="dialogTitle"
  [message]="dialogMessage"
  [buttons]="dialogButtons"
  (emitOnClick)="onConfirmatiButtonClick($event)"
></app-confirmation-dialog>
